import { render, staticRenderFns } from "./GeneralLiveStatsChart.component.vue?vue&type=template&id=b90a8dc4&scoped=true&"
import script from "./GeneralLiveStatsChart.component.vue?vue&type=script&lang=js&"
export * from "./GeneralLiveStatsChart.component.vue?vue&type=script&lang=js&"
import style0 from "./GeneralLiveStatsChart.component.vue?vue&type=style&index=0&id=b90a8dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90a8dc4",
  null
  
)

export default component.exports